module.exports = __webpack_public_path__ + "img/2001c00.jpg";